import { render, staticRenderFns } from "./ConfirmBroadcastModal.vue?vue&type=template&id=4e6389a6&"
import script from "./ConfirmBroadcastModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmBroadcastModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports